import { useEffect, useRef, useState } from "react";
import { useAppSelector } from "@/hooks";
import { Outlet, useSearchParams, useParams } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ResizablePanel, ResizablePanelGroup } from "@/components/ui/resizable";
import PlanSuccessModal from "@/components/subscription/PlanSuccessModal";
import Navbar from "../components/navbar/navbar";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import { SUBSCRIPTION_STATUS, USER_ROLES } from "@/utils/constants";
import { InformationCircleIcon } from "@heroicons/react/20/solid";
import Countdown, { CountdownRendererFn } from "react-countdown";
import { featureFlags } from "@/utils/featureFlags";
import { AppSidebar } from "@/components/sidebar/app-sidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useAuthStore } from "@/utils/UseAuthStore";

export default function DashboardLayout() {
  const [isOpen, setIsOpen] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const user = useAppSelector((state) => state.user.user);
  const plan = useAppSelector((state) => state.plan.plan);
  const sidebarKey = useRef("sidebar");
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn());

  const { height, width } = useWindowDimensions();

  const { noteId = "", folder = "" } = useParams<{
    folder: string;
    noteId: string;
  }>();

  const { templateId = "" } = useParams<{
    templateId: string;
  }>();

  useEffect(() => {
    const elem = document.getElementById("sentry-feedback");

    if (elem && !noteId) {
      elem.style.display = "";
    } else if (elem && noteId) {
      elem.style.display = "none";
    }
  }, [folder, noteId]);

  useEffect(() => {
    if (noteId || templateId) {
      setIsCollapsed(true);
      sidebarKey.current = "collapsed";
    } else {
      setIsCollapsed(false);
      sidebarKey.current = "sidebar";
    }
  }, [noteId, templateId]);

  const renderer: CountdownRendererFn = ({ days }) => {
    return <span> {days} days</span>;
  };

  const handleCloseModal = () => {
    if (searchParams.has("subscription")) {
      searchParams.delete("subscription");
      setSearchParams(searchParams);
    }
    setIsOpen(false);
  };

  useEffect(() => {
    if (searchParams.get("subscription") === "true") {
      setIsOpen(true);
    }
  }, []);

  const sidebarOpen = (open: boolean) => {
    setIsCollapsed(!open);
  };

  return (
    <SidebarProvider>
      {isLoggedIn ? (
        <>
          <AppSidebar isCollapsed={isCollapsed} sideOpen={sidebarOpen} />

          <div
            className="flex flex-col w-full"
            style={
              width >= 768 && !noteId && !templateId && isLoggedIn
                ? {}
                : width >= 768 && (noteId || templateId) && isLoggedIn
                ? {
                    width: `calc(100vw - ${isCollapsed ? 48 : 256}px)`,
                  }
                : {}
            }
          >
            <Navbar />
            {width >= 768 ? (
              <div
                style={{
                  height: `calc(100vh - 67px)`,
                }}
              >
                <TooltipProvider delayDuration={0}>
                  <ResizablePanelGroup direction="horizontal">
                    {/* <SidebarProvider
                  style={{
                    overflowY: "auto",
                    overflowX: "hidden",
                    height: "100%",
                    }}
                    >
                    {[SUBSCRIPTION_STATUS.TRIAL].includes(
                      user?.subscription_status!
                      ) && (
                        <div className="mx-2 mt-auto mb-2 rounded-xl border border-slate-500 p-3 text-xs text-center flex flex-col items-center">
                        <InformationCircleIcon className="my-1 h-5 w-5 text-slate-500" />
                        Your Trial Ends in
                        <div className="my-1">
                        <strong>
                        {plan?.trial_till && (
                          <Countdown
                          date={plan?.trial_till}
                          renderer={renderer}
                          />
                          )}
                          </strong>
                          </div>
                          </div>
                          )}
                          </SidebarProvider> */}
                    {/* </div> */}

                    <ResizablePanel id="panel-2" order={2}>
                      <div
                        style={{
                          overflow: "auto",
                          height: "calc(100vh - 65px)",
                        }}
                      >
                        <div id="outlet">
                          <Outlet />
                        </div>
                      </div>
                    </ResizablePanel>
                  </ResizablePanelGroup>
                </TooltipProvider>
              </div>
            ) : (
              <div id="outlet" className="lg:px-8">
                <Outlet />
              </div>
            )}
          </div>
          <PlanSuccessModal isOpen={isOpen} setIsOpen={handleCloseModal} />
        </>
      ) : (
        <div className="flex flex-col min-h-screen w-full">
          <Navbar />
          <div id="outlet" className="w-full">
            <Outlet />
          </div>
        </div>
      )}
    </SidebarProvider>
  );
}
